<!-- Masthead -->

<template>
	<div class="masthead-main wi8_font">
		<a href="/wi8/website_1001/">
			<div class="home-target wi8_font">
				What I Ate!
			</div>
		</a>

		<div class="menu-spacer"></div>

		<div class="menu-item wi8_font">
			<a href="/wi8/website_1001/about/">
				About
			</a>
		</div>

		<div class="menu-item wi8_font">
			<a href="/wi8/website_1001/contact">
				Contact
			</a>
		</div>

		<div class="menu-item wi8_font menu-item-active">
			<a href="/wi8/website_1001/publog/">
				PubLog
			</a>
		</div>

	</div>
</template>

<script>
export default {
	methods: {
		goHome() {
			this.$router.push("/")
			.catch(err => {
				// nothing
			})
		},
	},
}
</script>

<style scoped>
.masthead-main {
	height:30px;
	overflow: hidden;
	padding: 4px 0px 0px 5px;
	background-color: #FFF;
	border: solid 0px #090;
}

.home-target {
	display:inline-block;
	width: 122px;
	height:21px;
	overflow: hidden;
	white-space: nowrap;
	cursor: pointer;
	color: #999;
	font-size: 15px;
	padding: 1px 0px 0px 0px;
	border: solid 0px #C30;		
	border-right: solid 1px #CCC;		
}

.menu-item {
	display: inline-block;
	width: 70px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	color: #999;
	font-size: 12px;
	text-align: center;
	padding: 3px 0px 0px 0px;
	border: solid 0px #C30;
}

.menu-item-active {
	color: #000;
}

.menu-spacer {
	display: inline-block;
	width: 3px;
	height: 10px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #090;
}


a {
	color: inherit;
	text-decoration: none;
}

a:visited {
	color: inherit;
}

.home-target-orig {
		display:inline-block;
		width: 140px;
		height:40px;
		overflow: hidden;
		white-space: nowrap;
		cursor: pointer;
		font-size: 20px;
		color:#C54;
		text-shadow:
			2px 2px 1px #fff,
			-2px -2px 1px #fff,
			2px -2px 1px #fff,
			-2px 2px 1px #fff,
			0px 2px 1px #fff,
			2px 0px 1px #fff,
			0px -2px 1px #fff,
			-2px 0px 1px #fff;
		padding: 0px 0px 0px 10px;
		border: solid 0px #FFF;		
}
</style>
